import { render, staticRenderFns } from "./MakeRequest.vue?vue&type=template&id=4ea51fa5&scoped=true&"
import script from "./MakeRequest.vue?vue&type=script&lang=js&"
export * from "./MakeRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea51fa5",
  null
  
)

export default component.exports